import React from "react";
import { motion } from "framer-motion";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "../ui/accordion";
import { FAQS } from "../../constants/faq";

export default function Faq() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative bg-white py-24 lg:py-32"
    >
      <div className="mx-auto max-w-5xl px-5 sm:px-8">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3">
            <span className="h-px w-10 bg-brand-gold" />
            <span className="label-overline">FAQ</span>
          </div>
          <h2 className="mt-5 font-playfair text-3xl sm:text-4xl lg:text-5xl text-brand-navy leading-[1.1] tracking-tight text-balance">
            Preguntas <span className="italic text-brand-gold">frecuentes</span>
          </h2>
          <p className="mt-5 font-inter text-lg text-brand-mute leading-relaxed">
            Resolvemos las dudas más comunes sobre avalúos, peritajes y DRO en Puebla. Si tu
            caso es distinto, escríbenos por WhatsApp y te orientamos.
          </p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6 }}
          className="mt-12"
        >
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-brand-navy/10"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="py-6 text-left font-playfair text-lg lg:text-xl text-brand-navy hover:no-underline hover:text-brand-gold-dark"
                >
                  <span className="flex items-start gap-4">
                    <span className="font-mont text-xs text-brand-gold mt-1.5">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span>{f.q}</span>
                  </span>
                </AccordionTrigger>
                <AccordionContent className="pb-6 pl-10 font-inter text-base text-brand-mute leading-relaxed">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
